import { render, staticRenderFns } from "./ToWatchListest.vue?vue&type=template&id=c5171482&scoped=true&"
import script from "./ToWatchListest.vue?vue&type=script&lang=js&"
export * from "./ToWatchListest.vue?vue&type=script&lang=js&"
import style0 from "./ToWatchListest.vue?vue&type=style&index=0&id=c5171482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5171482",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\maixun_cxx\\private_library\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5171482')) {
      api.createRecord('c5171482', component.options)
    } else {
      api.reload('c5171482', component.options)
    }
    module.hot.accept("./ToWatchListest.vue?vue&type=template&id=c5171482&scoped=true&", function () {
      api.rerender('c5171482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/ToWatchListest.vue"
export default component.exports